import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tabs, Card, Avatar, Typography, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import dataService from "../../networks/api/service/dataService";

const { Title, Text } = Typography;
const { TabPane } = Tabs;

const DriverDetails = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const driver = state?.driver;
  const [tripHistory, setTripHistory] = useState([]);
  const [vehicleDetails,setVehicleDetails] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);

  

  useEffect(() => {

    const fetchDriverHistory = async () => {
      const driverId = driver._id;
      const vehicleId = "";
      if (driver._id) {
        setLoadingHistory(true);
        try {
          const response = await dataService.getTripHistory(vehicleId,driverId);
          // Assuming response has a property called `tripHistory`
          setTripHistory(response.data || []);
          setVehicleDetails(response.data.vehicle || [])
        } catch (error) {
          console.error("Error fetching driver history:", error);
        } finally {
          setLoadingHistory(false);
        }
      }
    };

    fetchDriverHistory();
  }, [driver]);

  if (!driver) {
    return <Text>No driver data found.</Text>;
  }
  
  

  return (
    <div style={{ maxWidth: 800, margin: "auto", padding: "20px" }}>
      <Button
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(-1)}
        style={{ marginBottom: 20 }}
      >
        Back
      </Button>

      <Card style={{ textAlign: "center", marginBottom: 20 }}>
        <Avatar src={driver.image} size={100} />
        <Title level={3} style={{ marginTop: 10 }}>
          {driver.driverName}
        </Title>
        <Text>
          Status:{" "}
          <b style={{ color: driver.isAssigned ? "red" : "green" }}>
            {driver.isAssigned ? "Unavailable" : "Available"}
          </b>
        </Text>
      </Card>

      <Tabs defaultActiveKey="1" type="line">
      <TabPane tab="Personal Info" key="1">
  <Text>📞 Phone: {driver.driverPhoneNumber}</Text>
  <br />
  <Text>📧 Email: {driver.driverEmail}</Text>
  <br />
  {tripHistory[0]?.vehicle ? (
    <>
      <hr style={{ margin: "10px 0" }} />
      <Title level={5} style={{ marginBottom: 5 }}>
        🚘 Assigned Vehicle
      </Title>
      <Text>Type: {tripHistory[0].vehicle.vehicleDetails}</Text>
      <br />
      <Text>Model: {tripHistory[0].vehicle.makeAndModel}</Text>
      <br />
      <Text>Reg No: {tripHistory[0].vehicle.registrationNum}</Text>
      <br />
      <Text>
        Insurance Valid Till:{" "}
        {new Date(tripHistory[0].vehicle.insuranceValidTill).toLocaleDateString()}
      </Text>
    </>
  ) : (
    <Text type="secondary">No assigned vehicle found.</Text>
  )}
</TabPane>

        <TabPane tab="License Info" key="2">
          <Text>🆔 DL Number: {driver.driverLicenseNum}</Text>
          <br />
          <Text>📅 DL Validity: {driver.licenceValidity}</Text>
        </TabPane>
        <TabPane tab="Assignment Status" key="3">
          <Text>
            The driver is currently{" "}
            <b style={{ color: driver.isAssigned ? "red" : "green" }}>
              {driver.isAssigned ? "Assigned" : "Available"}
            </b>
            .
          </Text>
        </TabPane>
        <TabPane tab="History" key="4">
  {tripHistory.length > 0 ? (
    <ul style={{ paddingLeft: 0 }}>
      {tripHistory.map((trip, index) => {
        const now = new Date();
        const start = new Date(trip.startDateTime);
        const end = new Date(trip.endDateTime);

        let status = "";
        if (now < start) {
          status = "Upcoming";
        } else if (now >= start && now <= end) {
          status = "In Progress";
        } else {
          status = "Completed";
        }

        return (
          <Card key={index} style={{ marginBottom: 20 }}>
            <Text>
              <b>Trip:</b> 🚗 {trip.startPoint} → {trip.endPoint}
            </Text>
            <br />
            <Text>
              <b>Start Date:</b> {new Date(trip.startDateTime).toLocaleString()}
            </Text>
            <br />
            <Text>
              <b>End Date:</b> {new Date(trip.endDateTime).toLocaleString()}
            </Text>
            <br />
            <Text>
              <b>Status:</b>{" "}
              <span
                style={{
                  color:
                    status === "Completed"
                      ? "green"
                      : status === "In Progress"
                      ? "orange"
                      : "blue",
                }}
              >
                {status}
              </span>
            </Text>

            {trip.vehicle && (
              <>
                <hr style={{ margin: "10px 0" }} />
                <Title level={5} style={{ marginBottom: 5 }}>
                  🚘 Assigned Vehicle
                </Title>
                <Text>Type: {trip.vehicle.vehicleDetails}</Text>
                <br />
                <Text>Model: {trip.vehicle.makeAndModel}</Text>
                <br />
                <Text>Reg No: {trip.vehicle.registrationNum}</Text>
                <br />
                <Text>
                  Insurance Valid Till:{" "}
                  {new Date(trip.vehicle.insuranceValidTill).toLocaleDateString()}
                </Text>
              </>
            )}
          </Card>
        );
      })}
    </ul>
  ) : (
    <Text type="secondary">No trip history available.</Text>
  )}
</TabPane>


      </Tabs>
    </div>
  );
};

export default DriverDetails;
